import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

interface IModalPrexistenceProps {
  open: boolean;
  toggle: any;
}

export default function ModalPreexistence(props: IModalPrexistenceProps) {
  const { open, toggle } = props;

  return (
    <Modal isOpen={open} size="lg">
      <ModalBody>
        <div className="row">
          <div className="col-3 d-none d-sm-block text-right">
            <img
              className="mt50"
              src="//sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/icono-aceptar.svg"
              alt="Icono aceptar"
            />
          </div>
          <div className="col-12 col-sm-8">
            <h2 className="px-36">Estimado cliente</h2>
            <p className="px-18">
              Debido a que posees una Preexistencia deber realizar la cotización
              con nuestros ejecutivos al número&nbsp;
              <span className="text-primary text-semibold">600 390 1000</span>
              &nbsp;o acércate a una de nuestras{' '}
              <span className="text-primary">sucursales</span>.
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="modal-footer col-12">
        <div className="row w-100 text-center justify-content-center">
          <div className="col-12 col-sm-5 col-md-4">
            <button
              className="btn white back-to-dps-from-modal"
              type="button"
              onClick={toggle(false)}
            >
              Cancelar
            </button>
          </div>
          <div className="col-12 col-sm-5 col-md-4">
            <a
              href="https://web.segurosfalabella.com/cl/sucursales/"
              className="btn primary go-to-product-description"
            >
              Aceptar
            </a>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}
